export const md = {
  title: 'Date de identificare (Impressum)',
  subtitle: 'Mențiuni obligatorii conform Regulamentului UE 2018/302 și Codului comercial estonian (äriseadustik) · Versiune: 10.05.2026',
  sections: [
    {
      id: 'company',
      title: 'Furnizorul serviciului',
      body:
        '**MATTALNET GRUPP OÜ**\nTuukri tn 19-315\n10120 Tallinn, Estonia\n\n- **Registrikood (numărul de înregistrare în registrul comerțului):** 14744075\n- **Cod TVA / KMKR number:** EE102519059\n- **EORI:** EE14744075\n- **D-U-N-S:** 536415812\n- **Registru:** Eesti äriregister (Registrul comerțului din Estonia)\n- **Forma juridică:** Osaühing (OÜ) — societate cu răspundere limitată conform dreptului estonian\n- **Autorizat și reglementat în:** Republica Estonia, Uniunea Europeană',
    },
    {
      id: 'responsible',
      title: 'Responsabil pentru conținut',
      body:
        '**Andreas A. Gleim**\nAdministrator / Responsabil pentru conținut conform Codului comercial estonian (äriseadustik) și § 18 MStV (Germania)\n\nE-mail: [logixa.one/kontakt](/kontakt)',
    },
    {
      id: 'contact',
      title: 'Contact',
      body:
        'E-mail: [logixa.one/kontakt](/kontakt)\nWebsite: [https://logixa.one](https://logixa.one)\n\nÎntrebările privind platforma, parteneriatele, presa și protecția datelor ne pot fi adresate prin adresa de e-mail de mai sus sau prin [formularul de contact](/kontakt).',
    },
    {
      id: 'eu',
      title: 'Soluționarea litigiilor la nivelul UE',
      body:
        'Comisia Europeană pune la dispoziție o platformă pentru soluționarea online a litigiilor (SOL):\n\n[https://ec.europa.eu/consumers/odr/](https://ec.europa.eu/consumers/odr/)\n\nNu suntem nici dispuși, nici obligați să participăm la o procedură de soluționare a litigiilor în fața unei autorități de soluționare a litigiilor cu consumatorii.',
    },
    {
      id: 'liability',
      title: 'Răspunderea pentru conținut',
      body:
        'În calitate de furnizor de servicii, suntem responsabili, conform § 7 alin. 1 TMG (Germania) și InfoTS estonian, pentru conținutul propriu de pe aceste pagini, în conformitate cu legile generale. Cu toate acestea, conform §§ 8-10 TMG, în calitate de furnizor de servicii nu avem obligația de a monitoriza informațiile transmise sau stocate ale terților.\n\nObligațiile de eliminare sau de blocare a utilizării informațiilor în conformitate cu legile generale rămân neafectate. O răspundere în acest sens este însă posibilă numai din momentul cunoașterii unei încălcări concrete a legii.',
    },
    {
      id: 'liability-links',
      title: 'Răspunderea pentru linkuri',
      body:
        'Oferta noastră conține linkuri către site-uri externe ale unor terți, asupra conținutului cărora nu avem nicio influență. De aceea, nu putem prelua nicio garanție pentru aceste conținuturi străine. Pentru conținutul paginilor către care se face trimitere este responsabil întotdeauna furnizorul sau operatorul respectiv al paginilor.',
    },
    {
      id: 'copyright',
      title: 'Drepturi de autor',
      body:
        'Conținutul și operele create de operatorii site-ului pe aceste pagini sunt protejate de dreptul de autor. Reproducerea, prelucrarea, distribuirea și orice fel de valorificare în afara limitelor dreptului de autor necesită acordul scris al autorului sau al creatorului respectiv.\n\nDescărcările și copiile acestei pagini sunt permise numai pentru uz privat, necomercial.',
    },
  ],
};
